// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container styles */
.self-modal-container {
    display: flex;
    justify-content: space-between;
    gap: 20px; 
    padding: 16px 8px; 
  }
  
  
  .self-modal-left {
    flex: 1 1; 
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-right: 10px; 
    border-right: 1px solid #e0e0e0; 
  }
  
  .self-modal-right {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-left: 10px;
  }
  
  .self-modal-left .MuiTextField-root,
  .self-modal-right .MuiTextField-root {
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: #333;
  }
  
  .self-modal-right .MuiTextField-root textarea {
    resize: none; 
    font-size: 14px;
    line-height: 1.5;
  }
  
  
  .MuiDialogTitle-root {
    font-family: 'Roboto', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #444;
    border-bottom: 1px solid #ddd; 
    padding: 12px 24px;
  }
  
  .MuiDialogContent-root {
    background-color: #f9f9f9;
    padding: 24px; 
  }
  
  
  .MuiDialogActions-root {
    justify-content: flex-end; 
    padding: 16px 24px; 
    border-top: 1px solid #ddd; 
  }
  
 
  .MuiButton-containedPrimary {
    background-color: #007bff; 
    color: white;
    font-weight: bold;
    text-transform: none; 
    padding: 8px 16px;
  }

  .reporttitle{
    font-family: "Inter";
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 21.78px !important;
    letter-spacing: 0.02em !important;
    text-align: left;
    color: #0070E9 !important;
  }
  
  .MuiButton-containedPrimary:hover {
    background-color: #0056b3; /* Darker blue on hover */
  }
  
  .MuiButton-textSecondary {
    color: #666;
    text-transform: none;
  }
  
  .MuiButton-textSecondary:hover {
    color: #333; 
  }
  
.self-modal-dialog {
    width: 800px; 
    height: 600px;
    max-width: none;
  }
  
  .self-modal-paper {
    width: 50%;
    height: 60%;
    max-width: 80%;
    padding: 16px; 
    background-color: #fff; 
    border-radius: 8px !important;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  .self-modal-title{
    font-family: "Inter";
    font-size: 18px !important;
    font-weight: 600 !important;
    line-height: 21.78px !important;
    letter-spacing: 0.02em !important;
    text-align: left;
    color: #0070E9 !important;
  }
 
.self-cancelButton {
    width: 97px !important;
    height: 39px !important;
    border-radius: 3px;
    border: 1px solid #FE602F !important;
    color: #FE602F !important;
    font-family: "Inter" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 19px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    background-color: transparent; 
    transition: all 0.3s ease; 
  }
  
  .self-cancelButton:hover {
    background-color: #FE602F !important; 
    color: #FFFFFF !important; 
  }
  
 
  .self-saveButton {
    width: 80px !important;
    height: 39px !important;
    border-radius: 3px !important;
    background-color: #FE602F !important;
    color: #FFFFFF !important;
    font-family: "Inter" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 19px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    border: none; 
    transition: all 0.3s ease;
  }
  
  .self-saveButton:hover {
    background-color: #D94C1E !important;
    color: #FFFFFF !important; 
  }
  .self-title{
    font-family: "Inter";
    font-size: 24px !important;
    font-weight: 600 !important;
    line-height: 21.78px !important;
    letter-spacing: 0.02em !important;
    text-align: left;
    color: #0070E9 !important;
  }
  `, "",{"version":3,"sources":["webpack://./src/views/panel/PerformanceManagement/EmployeeView/EmployeeView.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;EACnB;;;EAGA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;;IAEE,iCAAiC;IACjC,eAAe;IACf,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;;EAGA;IACE,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,aAAa;EACf;;;EAGA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;EAC5B;;;EAGA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB,EAAE,yBAAyB;EACtD;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;AAEF;IACI,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,wCAAwC;EAC1C;EACA;IACE,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,gBAAgB;IAChB,yBAAyB;EAC3B;;AAEF;IACI,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;IACjC,6BAA6B;IAC7B,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;;;EAGA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;IACjC,6BAA6B;IAC7B,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;EACA;IACE,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,gBAAgB;IAChB,yBAAyB;EAC3B","sourcesContent":["/* Container styles */\n.self-modal-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px; \n    padding: 16px 8px; \n  }\n  \n  \n  .self-modal-left {\n    flex: 1; \n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding-right: 10px; \n    border-right: 1px solid #e0e0e0; \n  }\n  \n  .self-modal-right {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding-left: 10px;\n  }\n  \n  .self-modal-left .MuiTextField-root,\n  .self-modal-right .MuiTextField-root {\n    font-family: 'Roboto', sans-serif;\n    font-size: 14px;\n    color: #333;\n  }\n  \n  .self-modal-right .MuiTextField-root textarea {\n    resize: none; \n    font-size: 14px;\n    line-height: 1.5;\n  }\n  \n  \n  .MuiDialogTitle-root {\n    font-family: 'Roboto', sans-serif;\n    font-size: 18px;\n    font-weight: 500;\n    color: #444;\n    border-bottom: 1px solid #ddd; \n    padding: 12px 24px;\n  }\n  \n  .MuiDialogContent-root {\n    background-color: #f9f9f9;\n    padding: 24px; \n  }\n  \n  \n  .MuiDialogActions-root {\n    justify-content: flex-end; \n    padding: 16px 24px; \n    border-top: 1px solid #ddd; \n  }\n  \n \n  .MuiButton-containedPrimary {\n    background-color: #007bff; \n    color: white;\n    font-weight: bold;\n    text-transform: none; \n    padding: 8px 16px;\n  }\n\n  .reporttitle{\n    font-family: \"Inter\";\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    line-height: 21.78px !important;\n    letter-spacing: 0.02em !important;\n    text-align: left;\n    color: #0070E9 !important;\n  }\n  \n  .MuiButton-containedPrimary:hover {\n    background-color: #0056b3; /* Darker blue on hover */\n  }\n  \n  .MuiButton-textSecondary {\n    color: #666;\n    text-transform: none;\n  }\n  \n  .MuiButton-textSecondary:hover {\n    color: #333; \n  }\n  \n.self-modal-dialog {\n    width: 800px; \n    height: 600px;\n    max-width: none;\n  }\n  \n  .self-modal-paper {\n    width: 50%;\n    height: 60%;\n    max-width: 80%;\n    padding: 16px; \n    background-color: #fff; \n    border-radius: 8px !important;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  .self-modal-title{\n    font-family: \"Inter\";\n    font-size: 18px !important;\n    font-weight: 600 !important;\n    line-height: 21.78px !important;\n    letter-spacing: 0.02em !important;\n    text-align: left;\n    color: #0070E9 !important;\n  }\n \n.self-cancelButton {\n    width: 97px !important;\n    height: 39px !important;\n    border-radius: 3px;\n    border: 1px solid #FE602F !important;\n    color: #FE602F !important;\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    line-height: 19px !important;\n    letter-spacing: 0.02em !important;\n    text-align: center !important;\n    background-color: transparent; \n    transition: all 0.3s ease; \n  }\n  \n  .self-cancelButton:hover {\n    background-color: #FE602F !important; \n    color: #FFFFFF !important; \n  }\n  \n \n  .self-saveButton {\n    width: 80px !important;\n    height: 39px !important;\n    border-radius: 3px !important;\n    background-color: #FE602F !important;\n    color: #FFFFFF !important;\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    line-height: 19px !important;\n    letter-spacing: 0.02em !important;\n    text-align: center !important;\n    border: none; \n    transition: all 0.3s ease;\n  }\n  \n  .self-saveButton:hover {\n    background-color: #D94C1E !important;\n    color: #FFFFFF !important; \n  }\n  .self-title{\n    font-family: \"Inter\";\n    font-size: 24px !important;\n    font-weight: 600 !important;\n    line-height: 21.78px !important;\n    letter-spacing: 0.02em !important;\n    text-align: left;\n    color: #0070E9 !important;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
